module.exports = __webpack_public_path__ + "img/loader-small-white.ed1f3694.gif";